<div class="p-megamenu-item-content" data-pc-section="content">
  <p-menu #menu [model]="languageItems" [popup]="true"></p-menu>
  <a pButton class="nav-link pi pi-language" (click)="menu.toggle($event); $event.stopPropagation()"></a>
</div>
